import { makeStyles, tokens } from '@fluentui/react-components';
import { iconSize } from '@/theme/scalingTokens';

export const useSectionIconStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '2.25rem',
    height: '2.25rem',
    minWidth: '2.25rem',
    borderRadius: '0.5rem',
    backgroundColor: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground1,
    flexShrink: 0,
  },
  icon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: iconSize(18),
    lineHeight: 1,
  },
});
